import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Select,
  message,
  Typography,
  Input,
} from "antd";
import dataService from "../networks/api/service/dataService";
import GreivanceTable from "../components/GreivanceTable";

function AdminGrievanceList() {
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch grievance list
  const getGrievanceList = async () => {
    try {
      const response = await dataService.getAllGrievance();
      if (response.code === 200) {
        setGrievances(response.data);
      } else {
        message.error("Failed to fetch grievances");
      }
    } catch (error) {
      message.error("Error fetching grievances");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGrievanceList();
  }, []);

  const getNewGrievanceList = () => {
    getGrievanceList();
  };

  return (
    <div style={{ padding: "2rem" }}>
      <GreivanceTable
        grievances={grievances}
        getNewGrievanceList={getNewGrievanceList}
        loading={loading}
      />
    </div>
  );
}

export default AdminGrievanceList;
